const data = [
  {
    Name: "Aaditya Khot",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995789/IMG_20240723_145343_-_Aaditya_Khot_lc2bog.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aaditya-khot-111672229?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "https://github.com/aadityafour7",
    InstagramProfile: "https://www.instagram.com/aaditya._.47?igsh=MWR3ZGdpaDR1eWd6eA==",
  },
  {
    Name: "Vedant Vedpathak",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995794/DSC_6845_-_0053_Vedant_Vedpathak_dwriph.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vedant-vedpathak-b54384229/",
    GitHubProfile: "https://github.com/vedantv3",
    InstagramProfile: "https://www.instagram.com/_vedantv3_/",
  },
  {
    Name: "Himanshu Mude",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995801/20230323_205541_-_Himanshu_Mude_fvrurf.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/himanshumude",
    GitHubProfile: "https://github.com/HimanshuMude",
    InstagramProfile: "https://www.instagram.com/himanshu_mude?igsh=MWg2ZDdrZGEycDJjNw==",
  },
  {
    Name: "Aaditya Patil",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995791/passport_photo_-_21610046_PATIL_AADITYA_RAJENDRA_a96pwi.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/aadi-exe",
    GitHubProfile: "https://github.com/Aaditya123-exe",
    InstagramProfile: "https://www.instagram.com/aadityapatil345",
  },
  {
    Name: "Mahesh Giri",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995796/DSC_2229_-_Mahesh_Giri_ugamky.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mahesh-giri-b10493230?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    GitHubProfile: "http://github.com/2002mahesh",
    InstagramProfile: "https://www.instagram.com/45_stylish_star?igsh=MWVhMm15bHU1dzhnbA==",
  },
  
  {
    Name: "Kalash Patil",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995780/WhatsApp_Image_2024-09-16_at_9.33.17_PM_-_Kalash_Patil_o1gs5v.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/kalashpatil33/",
    GitHubProfile: "https://github.com/kalashpatil33",
    InstagramProfile:
      "https://www.instagram.com/kalash.patil33",
  },
  
  {
    Name: "Mitali Patil",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995777/IMG_20221003_003849_155_-_Mitali_Patil_jrozsz.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/mitali-patil-3ab106231",
    GitHubProfile: "https://github.com/mitupatil18",
    InstagramProfile: "https://www.instagram.com/mitali.patil.20?igsh=MThuZG9uZmU1dDV0bg==",
  },
  {
    Name: "Parth Kulkarni",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995774/photo_-_Parth_Kulkarni_nch0z1.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/parth-kulkarni-554978233",
    GitHubProfile: "https://github.com/Parthk26",
    InstagramProfile:
      "https://instagram.com/parth_k026?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D",
  },
  {
    Name: "Kedarnath Chavan",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995772/profile-1_-_Kedarnath_Chavan_njxpew.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/kedarnathpc",
    GitHubProfile: "https://github.com/kedarnathpc",
    InstagramProfile:
      "https://www.instagram.com/kedarnathpc/",
  },
  {
    Name: "Vishwas Nalawade",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995770/Vishwasnalawade_-_Vishwas_Nalawade_voyihq.jpg",
    LinkedInProfile: "https://www.linkedin.com/in/vishwas-nalawade-106672229/",
    GitHubProfile: "https://github.com/Vishwas141",
    InstagramProfile: "",
  },
  {
    Name: "Pranav Kadam",
    Board: "Mentor",
    Position: "Mentor",
    Photo:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1726995769/pranav-kadam_2_-min_1_-_Pranav_Kadam_pdensw.jpg",
    LinkedInProfile:
      "https://www.linkedin.com/in/pranavkadam-",
    GitHubProfile: "https://github.com/pranav-kadam",
    InstagramProfile: "",
  }
];
export default data;
